import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function ToggleVisible() {
    this.defaultAttrs({
        buttonSelector: '[data-toggle-visible-button]',
        elementSelector: '[data-toggle-visible-element]',
        hideOnBodyClickAttribute: 'data-toggle-visible-hide-on-body-click',
    });

    this.toggleVisible = function() {
        const $element = this.select('elementSelector');
        if ($element.is('[data-active]')) {
            this.hideElement();
        } else {
            this.showElement();
        }
    };

    this.hideElement = function() {
        this.select('buttonSelector').removeAttr('data-active');
        this.select('elementSelector').removeAttr('data-active');
    };

    this.showElement = function() {
        this.select('buttonSelector').attr('data-active', '');
        this.select('elementSelector').attr('data-active', '');
    };

    this.bodyClick = function(e, data) {
        if (this.$node.attr('data-toggle-visible-hide-on-body-click') !== 'false') {
            if (!this.$node.is(data.target) && this.$node.has(data.target).length === 0) {
                this.hideElement();
            }
        }
    };

    this.after('initialize', function() {
        this.on('click', {
            buttonSelector: this.toggleVisible,
        });

        this.on(document, 'uiHideToggleVisible', this.bodyClick);
    });
}

export default defineComponent(ToggleVisible);



// WEBPACK FOOTER //
// ./src/js/component_ui/toggle-visible.js